import { render, staticRenderFns } from "./Order_partner_main.vue?vue&type=template&id=bb03d312&scoped=true&"
import script from "./Order_partner_main.vue?vue&type=script&lang=js&"
export * from "./Order_partner_main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb03d312",
  null
  
)

export default component.exports